export default __webpack_public_path__ + "static/media/chevron-down.9039f26c.svg";